module.exports = __webpack_public_path__ + "static/img/shooting01.52845c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/shooting01.jpg
// module id = pfpp
// module chunks = 0